/* =========================================================
   ANATOMIK.JS – DARK MODE + MARQUEE + CART + FALLBACKS
   + SIZE POPUP (HOME / COLECȚII) + CART POPUP
========================================================= */

console.log("ANATOMIK JS LOADED");

(function () {
  const html = document.documentElement;

  /* ---------------------------------------------
     1. CURĂȚĂ CLASELE DE EDITOR SHOPIFY
  --------------------------------------------- */
  function cleanShopifyEditorClasses() {
    html.classList.remove("light-theme");
    html.classList.remove("theme-editor-light");
    html.classList.remove("shopify-design-mode--light");
  }
  setInterval(cleanShopifyEditorClasses, 500);

  /* ---------------------------------------------
     2. DARK/LIGHT + LOCALSTORAGE
  --------------------------------------------- */
  function applyInitialTheme() {
    const saved = localStorage.getItem("theme");

    if (saved === "light") {
      html.classList.remove("dark");
    } else if (saved === "dark") {
      html.classList.add("dark");
    } else {
      try {
        if (
          window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
          html.classList.add("dark");
        } else {
          html.classList.remove("dark");
        }
      } catch (e) {
        html.classList.add("dark");
      }
    }

    updateToggleIndicator();
  }

  function updateToggleIndicator() {
    const indicator = document.querySelector(".toggle-indicator");
    if (!indicator) return;

    if (html.classList.contains("dark")) {
      indicator.style.transform = "translateX(100%)";
      indicator.style.backgroundColor = "#ef4444";
    } else {
      indicator.style.transform = "translateX(0%)";
      indicator.style.backgroundColor = "#ffffff";
    }
  }

  function toggleTheme() {
    html.classList.toggle("dark");
    localStorage.setItem(
      "theme",
      html.classList.contains("dark") ? "dark" : "light"
    );
    updateToggleIndicator();
  }

  function attachThemeToggle() {
    const btn = document.getElementById("theme-toggle");
    if (!btn) return;
    btn.addEventListener("click", toggleTheme);
  }

  /* ---------------------------------------------
     3. MARQUEE SCROLL (#tech-marquee)
  --------------------------------------------- */
  function initMarquee() {
    const marquee = document.getElementById("tech-marquee");
    if (!marquee) return;

    window.addEventListener("scroll", function () {
      const scrollY = window.scrollY || 0;
      marquee.style.transform = "translateX(-" + scrollY * 0.25 + "px)";
    });
  }

  /* ---------------------------------------------
     4. FALLBACK SVG PENTRU IMAGINI
  --------------------------------------------- */
  window.getMedicalFallback = function () {
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="400" height="500">
        <rect width="100%" height="100%" fill="#0f172a"/>
        <defs>
          <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M20 0 L0 0 0 20" stroke="#1e293b" stroke-width="1"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
        <g transform="translate(200,220)">
          <circle cx="0" cy="0" r="40" stroke="#ef4444" stroke-dasharray="5,5" fill="none">
            <animateTransform attributeName="transform" type="rotate" dur="10s" from="0" to="360" repeatCount="indefinite"/>
          </circle>
          <path d="M-15 -15 L15 15 M15 -15 L-15 15" stroke="#ef4444" stroke-width="3"/>
        </g>
        <text x="200" y="300" text-anchor="middle" fill="#94a3b8" font-family="monospace" font-size="14">IMG_DATA_LOSS</text>
        <text x="200" y="325" text-anchor="middle" fill="#475569" font-family="monospace" font-size="10">ERR_CODE:404</text>
      </svg>
    `;
    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  };

  /* ---------------------------------------------
     5. AJAX CART (UNIFICAT) + TOAST
  --------------------------------------------- */
  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || "/cart/add.js";
  }

  function getCartJsonUrl() {
    const base = "/cart.js";
    try {
      const current = new URL(window.location.href);
      if (current.search) return base + current.search;
    } catch (e) {}
    return base;
  }

  // 🔥 Verificare limită 20 buc / produs în CART înainte de ADD
  async function checkCartLimitBeforeAdd(variantId) {
    try {
      const res = await fetch("/cart.js", {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const cart = await res.json();

      const line = cart.items.find((i) => i.variant_id == variantId);

      // Dacă varianta nu e în coș -> ok
      if (!line) return true;

      if (line.quantity >= 20) {
        const popup = document.getElementById("cart-limit-popup");
        if (popup) {
          popup.classList.remove("hidden");
          popup.classList.add("flex");
        }
        return false;
      }

      return true;
    } catch (e) {
      console.warn("checkCartLimitBeforeAdd error:", e);
      // Dacă e eroare, nu blocăm userul – lăsăm add-to-cart să meargă
      return true;
    }
  }

  // ADD TO CART principal (product page, cards, size popup)
  window.anatomikAddToCart = async function (variantId) {
    if (!variantId) {
      console.warn("Variant ID missing for anatomikAddToCart");
      return;
    }

    // verificare limită 20
    const canAdd = await checkCartLimitBeforeAdd(variantId);
    if (!canAdd) return;

    fetch(getCartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      credentials: "same-origin",
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then((result) => {
        if (!result.ok) {
          console.warn("Add to cart error:", result.data);
          showToast("Nu am putut adăuga în coș", "error");
          return;
        }

        updateCartCount();

        // popup mini-cart dacă există
        if (typeof window.showCartPopup === "function") {
          window.showCartPopup();
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Eroare de rețea", "error");
      });
  };

  function updateCartCount() {
    const bubble = document.getElementById("cart-count");
    if (!bubble) return;

    fetch(getCartJsonUrl(), {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then((res) => res.json())
      .then((cart) => {
        if (typeof cart.item_count === "number") {
          bubble.innerText = cart.item_count;
        }
      })
      .catch(() => {});
  }

  function showToast(message, type) {
    const toast = document.createElement("div");
    toast.className =
      "fixed bottom-8 left-1/2 -translate-x-1/2 px-6 py-3 rounded-full text-sm shadow-2xl z-50 flex items-center gap-2 animate-float " +
      (type === "error"
        ? "bg-red-600 text-white"
        : "bg-slate-900 text-white");

    toast.innerHTML =
      '<i data-lucide="' +
      (type === "error" ? "alert-triangle" : "check") +
      `" class="w-4 h-4"></i>` +
      message;

    document.body.appendChild(toast);

    if (window.lucide && typeof window.lucide.createIcons === "function") {
      try {
        window.lucide.createIcons();
      } catch (e) {}
    }

    setTimeout(() => toast.remove(), 2500);
  }

  // Buton principal ATC din pagina de produs
  document.addEventListener("DOMContentLoaded", () => {
    const mainBtn = document.getElementById("main-atc-btn");
    if (!mainBtn) return;

    mainBtn.addEventListener("click", () => {
      const select = document.querySelector('select[name="id"]');
      let variantId = null;

      if (select) {
        variantId = select.value;
      } else {
        const hiddenInput = document.querySelector('input[name="id"]');
        if (hiddenInput) variantId = hiddenInput.value;
      }

      if (!variantId) {
        console.error("Variant ID not found in product page form.");
        return;
      }

      if (typeof window.anatomikAddToCart === "function") {
        window.anatomikAddToCart(variantId);
      } else {
        console.error("anatomikAddToCart() missing");
      }
    });
  });

  /* ---------------------------------------------
     6. LUCIDE ICONS INIT
  --------------------------------------------- */
  function initLucide() {
    if (window.lucide && typeof window.lucide.createIcons === "function") {
      try {
        window.lucide.createIcons();
      } catch (e) {}
    }
  }

  /* ---------------------------------------------
     7. SMOOTH SCROLL (nu atinge formulare)
  --------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        const href = anchor.getAttribute("href");

        if (!href || href === "#" || anchor.closest("form")) return;

        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  /* ---------------------------------------------
     8. SIZE POPUP – INIT + LOGIC
  --------------------------------------------- */
  function initSizePopup() {
    const overlay = document.getElementById("sizePickerOverlay");
    const popup = document.getElementById("sizePicker");
    const closeBtn = document.getElementById("closeSizePicker");
    const buttonsContainer = document.getElementById("sizePickerButtons");

    if (!overlay || !popup || !buttonsContainer) {
      console.warn("Size popup DOM missing");
      return;
    }

    function openSizePopup(variants) {
      buttonsContainer.innerHTML = "";

      variants.forEach((v) => {
        const btn = document.createElement("button");
        btn.className =
          "px-3 py-2 rounded-lg text-sm font-mono border border-slate-300 dark:border-slate-700 transition-colors size-option";

        if (!v.available) {
          btn.disabled = true;
          btn.classList.add(
            "opacity-40",
            "cursor-not-allowed",
            "size-option-unavailable"
          );
        }

        btn.textContent = v.public_title || v.title;

        btn.addEventListener("click", () => {
          if (!v.available) return;
          window.anatomikAddToCart(v.id);
          closeSizePopup();
        });

        buttonsContainer.appendChild(btn);
      });

      overlay.classList.remove("hidden");
      popup.classList.remove("hidden");

      requestAnimationFrame(() => {
        overlay.classList.add("opacity-100");
        popup.classList.add("opacity-100", "scale-100");
      });
    }

    function closeSizePopup() {
      overlay.classList.remove("opacity-100");
      popup.classList.remove("opacity-100", "scale-100");

      setTimeout(() => {
        overlay.classList.add("hidden");
        popup.classList.add("hidden");
      }, 200);
    }

    window.openSizePopup = openSizePopup;
    window.closeSizePopup = closeSizePopup;

    if (closeBtn) closeBtn.addEventListener("click", closeSizePopup);
    overlay.addEventListener("click", closeSizePopup);
  }

  /* ---------------------------------------------
     9. HANDLER GLOBAL – CARD ADD TO CART
  --------------------------------------------- */
  function initCardAtcHandler() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".anatomik-card-atc");
      if (!btn) return;

      const hasSize = btn.dataset.hasSize === "true";
      const variants = JSON.parse(btn.dataset.variants || "[]");
      const defaultVariant = btn.dataset.defaultVariant;

      if (
        hasSize &&
        variants.length > 1 &&
        typeof window.openSizePopup === "function"
      ) {
        window.openSizePopup(variants);
        return;
      }

      let variantId = defaultVariant;
      if (!variantId && variants.length > 0) {
        variantId = variants[0].id;
      }

      if (variantId) {
        window.anatomikAddToCart(variantId);
      } else {
        console.warn("No variant id found for card add to cart");
      }
    });
  }

  /* ---------------------------------------------
     10. CART POPUP – INIT
  --------------------------------------------- */
  function initCartPopup() {
    const overlay = document.getElementById("cartAddedPopupOverlay");
    const popup = document.getElementById("cartAddedPopup");
    const closeBtn = document.getElementById("closeCartPopup");

    if (!overlay || !popup) {
      console.warn("Cart popup DOM missing");
      return;
    }

    function showCartPopup() {
      overlay.classList.remove("hidden");
      popup.classList.remove("hidden");

      requestAnimationFrame(() => {
        overlay.classList.add("opacity-100");
        popup.classList.add("opacity-100", "translate-y-0");
      });
    }

    function hideCartPopup() {
      overlay.classList.remove("opacity-100");
      popup.classList.remove("opacity-100", "translate-y-0");

      setTimeout(() => {
        overlay.classList.add("hidden");
        popup.classList.add("hidden");
      }, 200);
    }

    window.showCartPopup = showCartPopup;
    window.hideCartPopup = hideCartPopup;

    overlay.addEventListener("click", hideCartPopup);
    if (closeBtn) closeBtn.addEventListener("click", hideCartPopup);
  }

  /* ---------------------------------------------
     11. INIT GLOBAL
  --------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    applyInitialTheme();
    attachThemeToggle();
    initMarquee();
    initSmoothScroll();
    initLucide();
    updateCartCount();

    initSizePopup();
    initCardAtcHandler();
    initCartPopup();
  });
})();

// Adaugă în scriptul tău principal
document.addEventListener("DOMContentLoaded", () => {  
  const drawer = document.getElementById("drawerMenu");
  const overlay = document.getElementById("drawerOverlay");
  const toggle = document.getElementById("drawerToggle");
  const closeBtn = document.getElementById("drawerClose");
  const body = document.body;

  const openDrawer = () => {
    drawer.classList.remove("-translate-x-full");
    overlay.classList.remove("opacity-0", "pointer-events-none");
    body.classList.add("drawer-open");
  };

  const closeDrawer = () => {
    drawer.classList.add("-translate-x-full");
    overlay.classList.add("opacity-0", "pointer-events-none");
    body.classList.remove("drawer-open");
  };

  toggle.addEventListener("click", openDrawer);
  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
});
